module.exports = __webpack_public_path__ + "img/買った・売れたときの3ステップ.8897aea4.png";